import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';

import { QUERY_POSTS } from '../utils/queries';

import SignupModal from '../components/SignupModal';

import spinner from '../assets/spinner.gif';

import './Blog.css';

const words = /(\S+\s+){1,20}(\w+\.)?/;

/**
 * Get first 10 words of text or first sentence up to period,
 * whichever is shorter.
 *
 * @param {string} descr
 */
function shorten(descr) {
  const shortened = descr.match(words);
  return (shortened && shortened[0]) || descr;
}

function Blog() {
  const dispatch = useDispatch();

  const currentUser = useSelector(state => state.currentUser);

  const { loading, data } = useQuery(QUERY_POSTS);

  const [posts, setPosts] = useState(null);
  const [isAdmin, setIsAdmin] = useState(null);


  useEffect(() => {
    if (data) {
      setPosts(data.posts.filter(post => isAdmin || post.active));
    }
  }, [data, loading, isAdmin, dispatch]);

  useEffect(() => {
    setIsAdmin(currentUser && currentUser.admin);
  }, [currentUser, setIsAdmin]);

  return (
    <>
      <nav className="breadcrumb"><Link to="/">Home</Link></nav>

          <div>
            <h2>Articles</h2>

            {isAdmin ? <Link to={`/blog/add`}>Add Post</Link> : null}

            {posts && posts.length ? (
              <div>
                {posts.map((post, index) =>
                  <div className="article" key={post._id}>
                    <h3>{post.title}</h3>
                    { /*********** FIXME: HAVING THIS LAYOUT DUPLICATED CAUSES LOTS OF BUGS, REFACTOR THIS ********* */
                      (index % 2) ? (
                        <div className="left">
                          {post.image && <img className="desktop" src={`/image/${post.image}`} alt=" " />}
                          {post.image && <img className="mobile" src={`/image/${post.image}`} alt=" " />}
                          <p>
                            {shorten(post.post)} ...
                            <Link to={`/blog/${post._id}`}>Read&nbsp;more</Link>
                            <span className="post-controls">
                              {isAdmin ? <Link className="btn btn-sm btn-primary" to={`/blog/edit/${post._id}`}>Edit</Link> : null}
                              {isAdmin && ! post.active ? <strong>Post not active</strong> : null}
                            </span>
                          </p>
                        </div>
                      ) : (
                        <div className="right">
                          {post.image && <img className="mobile" src={`/image/${post.image}`} alt=" " />}
                          <p>
                            {shorten(post.post)} ...
                            <Link to={`/blog/${post._id}`}>Read&nbsp;more</Link>
                            <span className="post-controls">
                              {isAdmin ? <Link className="btn btn-sm btn-primary" to={`/blog/edit/${post._id}`}>Edit</Link> : null}
                              {isAdmin && ! post.active ? <strong>Post not active</strong> : null}
                            </span>
                          </p>
                          {post.image && <img className="desktop" src={`/image/${post.image}`} alt=" " />}
                        </div>
                      )
                    }
                  </div>
                )}
              </div>
            ) : null}
        </div>

      <SignupModal />

      {loading ? <img src={spinner} alt="loading" /> : null}
    </>
  );
}

export default Blog;

